<template>
  <div
    id="cta"
    v-wave="showVWave"
    class="flex w-full rounded-full text-white justify-center items-center p-4 bg md:cursor-pointer"
    :style="{
      background: color === 'yellow' ?  '#FFAA1A' : color === 'light' ? '#d2c2f3' : '#723BE3',
      color: color === 'light' ? '#723BE3': 'white',
      opacity: disable ? 0.7 : 1
    }"
    @click="clickCta">
    <div id="button-label" class="w-full flex justify-center h-6 items-center">
      <span v-if="!loading">{{ label }}</span>
      <hollow-dots-spinner
        v-if="loading"
        :animationDuration="750"
        :dotSize="12"
        :dotsNum="3"
        color="white"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HollowDotsSpinner } from 'epic-spinners';

const props = defineProps({
  disable: {
    type: Boolean,
    default: false,
    required: false
  },
  label: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false,
    required: false
  },
  color: {
    type: String,
    default: 'purple',
    required: false
  }
});
const emit = defineEmits(['clickEvent']);

const showVWave = !props.disable;

const clickCta = () => {
  if (!props.disable)
    emit('clickEvent');
};
</script>

<style scoped lang="scss">
@use "../assets/vars" as *;

.disable {
  background-color: $disable-color;
}
</style>
